export const navListItemSx = {
  height: '20%',
  textAlign: 'center',
};
